import { render } from "./FilterMarcas.vue?vue&type=template&id=d507f8f8&scoped=true&ts=true"
import script from "./FilterMarcas.vue?vue&type=script&lang=ts"
export * from "./FilterMarcas.vue?vue&type=script&lang=ts"

import "./FilterMarcas.vue?vue&type=style&index=0&id=d507f8f8&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d507f8f8"]])

export default __exports__